import React from "react";

import { BriefType } from "../../../../../../constants/types";
import { StatusSection } from "../../../../../../features/common-attributes/components/status-section/status-section.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlStatus = (props: CbTemplateControlProps) => (
  <StatusSection
    form={props.form}
    label="Status"
    name="status"
    pageType={BriefType.CAMPAIGN_BRIEF}
    userPermissions={props.userPermissions}
  />
);
